import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import ProductCard from "../components/ProductCard";
import Sorter from "../components/Sorter";
import Filter from "../components/Filter";
import useCollection from "../Hooks/useCollection";
import CategoryCarousel from "../components/CategoryCarousel";

const CollectionPage = () => {

  const { collectionName } = useParams();
  const { search, loading, error } = useCollection();
  const [items, setItems] = useState([]);
  const [filters, setFilters] = useState({});
  const [availableFilters, setAvailableFilters] = useState({});
  const [selectedFilters, setSelectedFilters] = useState({});
  const [sortOrder, setSortOrder] = useState("featured");
  const [categories, setCategories] = useState([]);
  const [gridColumns, setGridColumns] = useState(4); // Default to 4 columns
  useEffect(() => {
    setFilters({});
    setSelectedFilters({});
    window.scroll(0,0)
  }, [collectionName]);
  // Media query for mobile screens
  const isMobile = useMediaQuery({ maxWidth: 768 });
useEffect(()=>{
  if(isMobile){
    setGridColumns(2)
  }
},[isMobile])
  // Define grid options based on screen size
  const gridOptions = isMobile
    ? [{ cols: 1, icon: "grid-cols-1" }, { cols: 2, icon: "grid-cols-2" }]
    : [
        { cols: 2, icon: "grid-cols-2" },
        { cols: 3, icon: "grid-cols-3" },
        { cols: 4, icon: "grid-cols-4" },
      ];

  useEffect(() => {
    fetchData();
  }, [collectionName, filters, sortOrder]);

  const fetchData = async () => {
    const result = await search(collectionName, filters, sortOrder);
    if (result) {
      setCategories(result?.data?.categories || []);
      const products = result?.data?.products || [];
      if (result?.data?.filters?.length > 0) setAvailableFilters(result?.data?.filters);
      setItems(products);
    }
  };

  const getCardHeight = () => {
    if (isMobile) {
      return 350; // Reduced height for mobile
    }
    switch (gridColumns) {
      case 2:
        return 800;
      case 3:
        return 650;
      case 4:
      default:
        return 550;
    }
  };
  return (
    <div className="collection-page">
      <div className="flex justify-center items-center">
      <div className="md:w-3/4 w-full">
        <CategoryCarousel collectionName={collectionName?.split('&')[0]} categories={categories} />
      </div>
      </div>
      {/* Breadcrumb and Grid Layout Icons */}
      <div className="flex justify-between items-center mb-4 md:px-5 px-2">
        {/* Breadcrumb */}
        <div className="breadcrumb flex items-center text-gray-500">
          <Link to="/" className="hover:underline text-sm">
            Home
          </Link>{" "}
          <i className="fa-solid fa-chevron-right text-xs mx-2"></i>
          <Link
            to={`/collections/${collectionName}`}
            className="hover:underline text-sm text-black font-medium"
          >{` ${collectionName?.split('&')[0]}`}</Link>
        </div>

        {/* Dynamic Grid Layout Icons */}
        <div className="inline-flex space-x-2">
          {gridOptions.map((option) => (
            <div
              key={option.cols}
              className={`border ${
                gridColumns === option.cols
                  ? "border-gray-800"
                  : "border-gray-300"
              } cursor-pointer`}
              onClick={() => setGridColumns(option.cols)}
            >
              <div className="flex space-x-1 p-1">
                {Array(option.cols)
                  .fill(0)
                  .map((_, idx) => (
                    <div key={idx} className="h-5 w-3 bg-gray-800"></div>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-between mb-6 md:px-5 px-2">
        <Filter setFilters={setFilters} collectionName={collectionName} availableFilters={availableFilters} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters}/>
        <Sorter setSortOrder={setSortOrder} />
      </div>

      {/* Dynamic Grid Layout */}
      <div className={`md:mb-12 md:px-5 px-2 grid grid-cols-${gridColumns} md:gap-4 gap-2`}>
        {items.map((product) => product.price > 0 && (
         
          <ProductCard
            id={product.product_id}
            key={product.product_id}
            height={getCardHeight()}
            name={product.product_name}
            description={product.description}
            price={product.price}
            image={product.images}
            addToBag={true}
            isImageArray={true}
            navigateLink={`/product/${product.product_id}`}
            rating={product.average_rating}
            stock={product.stock}
           
          />
        ))}
      </div>
    </div>
  );
};

export default CollectionPage;
